import type { ReactNode } from 'react'
import { ToggleChip } from '../../ui/Chip'
import { DAY_PARTS, type DayPart, type Filters } from '../../lib/browse'
import { r3f, type R3fKey } from '../../copyR3Filters'

/** Monday first, the way a week reads on a calendar here; stored as 0 = Sunday like the server. */
const WEEK = [1, 2, 3, 4, 5, 6, 0]
const Tip = ({ children }: { children: ReactNode }) => <p className="t-caption -mt-1 mb-2 text-ink-2">{children}</p>

/**
 * Round 3, Lane 3 (R-103 / B-166, blind r4 priya: a night-shift visitor saw 7 PM events first): time of day and weekday
 * chips in the filter sheet. Multi-select; none = any. The server's rule (_shared/browse_filters.ts passesTime): an event
 * by its start, a place by its opening hours, a place with no hours stays in, which the tip says.
 */
export function TimeFilter({ f, onChange }: { f: Filters; onChange: (p: Partial<Filters>) => void }) {
  const parts = f.parts ?? []
  const days = f.days ?? []
  const togglePart = (p: DayPart) => onChange({ parts: DAY_PARTS.filter((x) => (x === p ? !parts.includes(p) : parts.includes(x))) })
  const toggleDay = (d: number) => onChange({ days: [0, 1, 2, 3, 4, 5, 6].filter((x) => (x === d ? !days.includes(d) : days.includes(x))) })
  return (
    <>
      <fieldset data-review-id="time-filter">
        <legend className="t-eyebrow mb-2 text-ink-2">{r3f('r3f.time.legend')}</legend>
        <Tip>{r3f('r3f.time.tip')}</Tip>
        <div className="flex flex-wrap gap-2">
          {DAY_PARTS.map((p) => <ToggleChip key={p} on={parts.includes(p)} onToggle={() => togglePart(p)}>{r3f(`r3f.part.${p}` as R3fKey)}</ToggleChip>)}
        </div>
      </fieldset>
      <fieldset data-review-id="day-filter">
        <legend className="t-eyebrow mb-2 text-ink-2">{r3f('r3f.days.legend')}</legend>
        <Tip>{r3f('r3f.days.tip')}</Tip>
        <div className="flex flex-wrap gap-2">
          {WEEK.map((d) => (
            <ToggleChip key={d} on={days.includes(d)} onToggle={() => toggleDay(d)}>
              <span aria-hidden="true">{r3f(`r3f.day.${d}` as R3fKey)}</span><span className="sr-only">{r3f(`r3f.day_long.${d}` as R3fKey)}</span>
            </ToggleChip>
          ))}
        </div>
      </fieldset>
    </>
  )
}
